import { createFileRoute } from "@tanstack/react-router";
import { preloadSourcingReviewQueue } from "@/pages/admin-sourcing-review/api/fetch-sourcing-review-queue-query";
import { searchParams } from "@/pages/admin-sourcing-review/model/search-params";
import { SourcingReviewPage } from "@/pages/admin-sourcing-review/ui/sourcing-review-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/sourcing/review/",
)({
  component: SourcingReviewPage,
  loaderDeps: ({ search }) => search,
  loader: ({ deps }) => preloadSourcingReviewQueue(deps),
  validateSearch: searchParams,
});
